// Internal release switch for the Flow Read column/filter. Hidden by default so
// it stays out of the launch build, and re-enabled for testing by adding
// `?read=1` (or `?read=true`/`?read=on`) to the URL.
//
// This is read once at module load (the value feeds module-level styled-component
// grid templates and header arrays), so reload the page with the query param to
// toggle it. On the server (SSR) it always resolves to false.
export const READ_MODE_QUERY_PARAM = 'read';

const isReadModeQueryEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const value = new URLSearchParams(window.location.search).get(READ_MODE_QUERY_PARAM);
    return value === '1' || value === 'true' || value === 'on';
  } catch {
    return false;
  }
};

export const ENABLE_OPTION_FLOW_READ_MODE = isReadModeQueryEnabled();
